<template>
  <b-form-group
    label="Sözleşme Başlangıç Tarihi"
    label-for="sdate"
  >
    <b-form-datepicker
      id="sdate"
      v-model="dataItem.tenants.sdate"
      v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
      :disabled="editable || isDisabled"
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'TenantStart',
  components: {
    BFormDatepicker,
    BFormGroup,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
    editable() {
      if (this.dataItem.tenants.created) {
        const endDate = moment(this.dataItem.tenants.created).add(30, 'day')
        const today = moment()
        return !(endDate.diff(today, 'days') > 0)
      }
      return true
    },
  },
}
</script>
